import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqImportar', {
    template: template,
    controller: nominasCargacontpaqImportarComponent,
    bindings: {
      idNomina: '<',
      onClose: '&',
    },
  });

function nominasCargacontpaqImportarComponent() {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.aceptar = aceptar;
  $ctrl.cerrar = cerrar;
  $ctrl.eliminar = eliminar;
  $ctrl.grid = null;
  $ctrl.headers = undefined;
  $ctrl.data = null;
  $ctrl.error = null;
  $ctrl.alertas = null;
  $ctrl.actualizar = actualizar;
  $ctrl.data = null;

  function $onInit() {
  }

  function actualizar(data) {
    $ctrl.error = null;
    $ctrl.alertas = [];

    if (!data)
      return;

    if (data.identificador < 0) {
      $ctrl.error = 'No se ha especificado ninguna columna como identificador del registro.';

      return;
    }

    if (!data.indices.length) {
      $ctrl.error = 'No se ha especificado ninguna columna como índice del registro.';

      return;
    }

    $ctrl.alertas = data.encabezados
      .reduce(function (alertas, encabezado) {
        if (!encabezado.id)
          alertas.push('Se omitirá la columna "' + encabezado.descripcion + '"');

        return alertas;
      }, []);

    $ctrl.data = data;
  }

  function eliminar() {
    $ctrl.grid = null;
    $ctrl.data = null;
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}});
  }

  function aceptar() {
    cerrar($ctrl.data);
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/importar/component.js